export function waNumber(raw) {
  return (raw || "").replace(/[^0-9]/g, "");
}

export function waLink(raw, message) {
  const digits = waNumber(raw);
  if (!digits) return null;
  const normalized = digits.startsWith("0") ? `62${digits.slice(1)}` : digits;
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message || "")}`;
}

export function waHref(content) {
  return waLink(content?.whatsapp, content?.whatsappMessage) || "#kontak";
}
